import React, { useEffect, useRef, useState } from "react";

import { map, size } from 'lodash';

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { publicRoutePaths } from "@/routes/public.routes.config";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const PartnerLogos = ({ ourPartner }) => {
  const sectionRef = useRef(null);

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const partnersLogoRef = useRef(null);

  const options = {
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    navText: ["<<", ">>"],
    responsive: {
      0: { items: 1 },
      500: { items: 2 },
      600: { items: 2 },
      1000: { items: 5 },
      1280: { items: 6 },
      1440: { items: 7 },
    },
    slideBy: 1,
  };

  const [sliders, setSliders] = useState([]);

  const goToNext = () => {
    partnersLogoRef.current.next();
  };

  const goToPrev = () => {
    partnersLogoRef.current.prev();
  };

  useEffect(() => {
    if (size(ourPartner) > 0) {
      const perSlide = 2;
      const slides = [];
      const N = ourPartner.length;

      let i = 0;
      while (slides.length < N * 2) { // repeat enough slides for looping
        const slide = [];
        for (let j = 0; j < perSlide; j++) {
          slide.push(ourPartner[(i + j) % N]);
        }
        slides.push(slide);
        i = (i + perSlide) % N; // move forward by perSlide
      }

      setSliders(slides);
    }

  }, [ourPartner]);

  return (
    <section ref={sectionRef} className={`our-partner-wrape`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xxl-2"></div>
          <div className="col-xxl-8">
            <div className="head-text center">
              <motion.h2 className={`head center animate-child`}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Our Partners</motion.h2>
              <motion.p className={`text animate-child`}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.3}
                variants={fadeUpVariant}
              >
                Trusted by companies across the globe, our partners strengthen
                the network and enable seamless trade opportunities for
                businesses everywhere.
              </motion.p>
            </div>
          </div>

          <div className="col-xxl-12">
            <motion.div className={`crousel-wrape animate-child`}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              <OwlCarousel className="owl-theme" {...options} ref={partnersLogoRef}>
                {
                  map(sliders, (slide, sIndex) => (
                    <div className="partner-column" key={`partner-column-slide_${sIndex}`}>

                      {map(slide, (item, key) => {
                        if (item?.image && item?.url) {
                          const isExternal = !item.url.startsWith("/");
                          const normalizedUrl = isExternal
                            ? item.url.startsWith("http")
                              ? item.url
                              : `https://${item.url}`
                            : item.url;

                          return (

                            <Link
                              to={normalizedUrl}
                              {...(isExternal
                                ? { target: "_blank", rel: "noreferrer" }
                                : {})}
                              className="slide partner-logo-slide"
                              key={`partner-logo-slide-${sIndex}-${item.title}`}
                            >
                              <img
                                className="partner-logo-img"
                                src={item.image}
                                alt={item.title}
                                loading="lazy"
                                width={152}
                                height={92}
                              />
                            </Link>

                          );
                        }
                        return null;
                      })}
                    </div>
                  )
                  )}

              </OwlCarousel>

              <div className="nav-ctrl">
                <button type="button" className="btn prev" onClick={goToPrev}>
                  <i className="sprite"></i>
                </button>
                <button type="button" className="btn next" onClick={goToNext}>
                  <i className="sprite"></i>
                </button>
              </div>

              <motion.div className={`btn-wrape center animate-child mt-3`}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.3}
                variants={fadeUpVariant}
                style={{ textAlign: "center" }}
              >
                {(
                  <Link to={publicRoutePaths.OUR_PARTNERS_DETAIL.path} title="View All" className="btn outline mt-4"
                    target={"_blank"}
                    rel={"noopener noreferrer"}>
                    View All
                  </Link>
                )}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerLogos;
